import { useLayoutEffect } from 'react';

export function useScrollToSection(
	section: React.RefObject<HTMLDivElement> | null,
	offset?: number,
) {
	useLayoutEffect(() => {
		if (section) {
			let offsetTop = section?.current?.offsetTop ?? 0;
			offsetTop = offset ? offsetTop - offset : offsetTop;
			window.scrollTo(0, offsetTop);
		}
	}, [section, offset]);
}
